module.exports = __webpack_public_path__ + "img/13.d22d224b.jpg";